import { useEffect, useState } from "react";
import useCurrentUser from "@/hooks/useCurrentUser";
import useNavigateTo from "@/hooks/useNavigateTo";
import { useUserV1Store } from "@/store/v1";

interface Props {
  children: React.ReactNode;
}

const AuthStatusProvider = (props: Props) => {
  const navigateTo = useNavigateTo();
  const currentUser = useCurrentUser();
  const userV1Store = useUserV1Store();
  const [isInitialCheckDone, setIsInitialCheckDone] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setIsInitialCheckDone(true);
      return;
    }

    // 只在首次加载时检查用户状态
    const checkAuthStatus = async () => {
      try {
        // 尝试获取当前用户信息
        await userV1Store.fetchCurrentUser();
      } catch (error) {
        // 如果获取失败（未登录），跳转到 explore 页面
        navigateTo("/explore");
      } finally {
        setIsInitialCheckDone(true);
      }
    };

    if (!isInitialCheckDone) {
      checkAuthStatus();
    }
  }, [currentUser, isInitialCheckDone]);

  // 在初始检查完成前，不渲染子组件，避免闪烁
  if (!isInitialCheckDone) {
    return null;
  }

  // 如果检查完成后仍然没有用户，说明未登录，不渲染子组件
  if (!currentUser) {
    return null;
  }

  return <>{props.children}</>;
};

export default AuthStatusProvider;
